import React, { useMemo } from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import { Size } from '../../../../../../Enums/Size.enum';
import { WorkplaceCertificateType } from '../../../../../../graphql/graphql';
import ManagerCertificateUploadWizard from '../ManagerCertificateUpload/ManagerCertificateUploadWizard';

interface Props extends BaseModalProps {
	certificateId?: string;
	onDelete: () => void;
	onFinish: () => void;
	certificateType: WorkplaceCertificateType;
}

const ManagerCertificateUploadWizardModal: React.FC<Props> = props => {
	const title: string = useMemo(() => {
		if (props.certificateType === WorkplaceCertificateType.Commercial) {
			return 'component.certificates.commerce.step1.title';
		} else if (props.certificateType === WorkplaceCertificateType.Sukl) {
			return 'component.certificates.uploadSUKL';
		}
		return 'component.certificates.uploadCertificate';
	}, [props.certificateType]);

	return (
		<BaseModal {...props} title={title} size={Size.LG}>
			<ManagerCertificateUploadWizard
				type={props.certificateType}
				certificateId={props.certificateId}
				onDelete={props.onDelete}
				onFinish={props.onFinish}
			/>
		</BaseModal>
	);
};

export default ManagerCertificateUploadWizardModal;
